/** Broad paddle wheel on a low slate pier; splash is static wet edging, never animation. */
import { checkEnvelope, checkScope, el, partGroup } from '../../svg';
import type { PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, beam, grainRng, ground, line, ring, rivet, type WheelArt } from './machinerySvg';
export interface UndershotParams { readonly paddles: number; readonly splash: number }
export type UndershotRecipe = PieceRecipe<'mill.waterwheel_undershot.v1', UndershotParams>;
export const UNDERSHOT_FRAME = { w: 210, h: 160 } as const;
export const MILL_UNDERSHOT: UndershotRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.waterwheel_undershot.default.v1', generatorId: 'mill.waterwheel_undershot.v1',
  seed: 20071002, paletteId: 'millrace_amber', params: { paddles: 10, splash: 0.65 },
};
export function buildUndershot(recipe: UndershotRecipe, p: ResolvedPalette, scope: string): WheelArt {
  checkEnvelope(recipe, MILL_UNDERSHOT.generatorId); checkScope(scope);
  const paddles = amount(recipe.params.paddles, 'paddles', 8, 12, true), splash = amount(recipe.params.splash, 'splash');
  const random = grainRng(recipe), parts: string[] = [], axle = { x: 105, y: 74 };
  let supportArt = ground(210, 160, p)
    + el('path', { d: 'M30 154L34 129L62 127L69 154ZM141 154L148 127L178 130L182 154Z', fill: p.stoneBase, stroke: p.outline, 'stroke-width': 1.5 })
    + beam(51, 132, 103, 77, 12, p) + beam(157, 132, 107, 77, 12, p) + beam(51, 133, 157, 133, 7, p)
    + rivet(55, 132, p) + rivet(153, 132, p);
  for (let i = 0; i < 7; i++) supportArt += el('ellipse', { cx: 24 + i * 27, cy: 150 + random(`water.${i}`) * 3, rx: 7 + random(`length.${i}`) * 6, ry: 1.3, fill: p.waterLight, opacity: splash * 0.8 });
  const support = partGroup(parts, 'undershot-pier', supportArt);
  let wheelArt = '';
  for (let i = 0; i < paddles; i++) {
    const a = i * 360 / paddles;
    wheelArt += el('g', { transform: `rotate(${a})` },
      beam(0, -9, 0, -54, 6, p)
      + el('path', { d: 'M-21 -64L19 -64L21 -51L-20 -51Z', fill: p.woodBase, stroke: p.outline, 'stroke-width': 1.5 })
      + line(-18, -61, 17, -61, p.woodLight, 2)
      + line(-17 + random(`split.${i}`) * 8, -56, 13, -55, p.woodShadow, 0.8)
      + rivet(-12, -58, p, 1.4) + rivet(12, -58, p, 1.4));
  }
  const wheel = partGroup(parts, 'undershot-wheel', el('g', { id: `${scope}_wheel`, transform: `translate(${axle.x} ${axle.y})` },
    wheelArt + ring(0, 0, 44, 5, p)
    + el('circle', { cx: 0, cy: 0, r: 12, fill: p.paperBase, stroke: p.outline, 'stroke-width': 2 })
    + rivet(0, 0, p, 5)));
  return { frame: UNDERSHOT_FRAME, body: support + wheel, anchors: { support: { x: 105, y: 160 }, axle }, parts, openings: [], layers: { support, wheel } };
}
